import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { FiArrowLeft, FiArrowRight, FiClock, FiMapPin, FiUsers, FiAward } from 'react-icons/fi';
import './halloween.css';

const registrationUrl = 'https://volleyballlife.com/event/41927?tab=information';

export default function HalloweenPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return <div className="halloween-page">
    <Helmet>
      <title>Halloween Coed 4s | October 31 | GrassVB</title>
      <meta name="description" content="Warm up for Snowbird Showdown with Halloween Coed 4s in Tucson on October 31, 2026. Coed A and B, $60 per team, and a $100 team costume contest." />
      <link rel="canonical" href="https://grassvb.com/halloween" />
    </Helmet>
    <header className="hw-header">
      <a href="/"><FiArrowLeft aria-hidden="true" /> Snowbird Showdown</a>
      <a className="hw-button" href={registrationUrl}>Register your team <FiArrowRight aria-hidden="true" /></a>
    </header>
    <main>
      <section className="hw-hero" aria-labelledby="hw-title">
        <img src={`${process.env.PUBLIC_URL}/logo-preview/grass-courts.jpg`} alt="" fetchPriority="high" />
        <div className="hw-hero-copy">
          <p className="hw-eyebrow">OCTOBER 31, 2026 / TUCSON, ARIZONA</p>
          <h1 id="hw-title">Halloween<br />Coed 4s</h1>
          <p>Bring your team. Bring your costumes.<br />Get your Snowbird warm-up on the grass.</p>
          <a className="hw-button" href={registrationUrl}>Register on VolleyballLife <FiArrowRight aria-hidden="true" /></a>
        </div>
      </section>
      <section className="hw-details hw-wrap" aria-labelledby="hw-details-title">
        <p className="hw-eyebrow">YOUR HALLOWEEN GAME PLAN</p>
        <h2 id="hw-details-title">One day. Four teammates. All grass.</h2>
        <dl className="hw-facts">
          <div><dt><FiMapPin aria-hidden="true" /> Where</dt><dd>Kino Sports Complex - South<span>Tucson, Arizona</span></dd></div>
          <div><dt><FiClock aria-hidden="true" /> When</dt><dd>Saturday, October 31<span>Check-in: 7:30 AM<br />First serve: 8:00 AM</span></dd></div>
          <div><dt><FiUsers aria-hidden="true" /> Divisions & entry</dt><dd>Coed A & Coed B<span>4 players per team<br /><strong>$60 per team</strong></span></dd></div>
        </dl>
        <p className="hw-deadline">Registration closes October 30 at 5:00 PM. Register through VolleyballLife for the latest availability.</p>
      </section>
      <section className="hw-costumes" aria-labelledby="hw-costumes-title">
        <div className="hw-wrap hw-costumes-inner">
          <FiAward className="hw-award" aria-hidden="true" />
          <div><p className="hw-eyebrow">TEAM COSTUME CONTEST</p><h2 id="hw-costumes-title">Dress together. Win $100.</h2><p>Show up in a group costume with your team for a chance to win $100. Our Instagram followers will decide the winner.</p></div>
        </div>
      </section>
      <section className="hw-wrap hw-final" aria-labelledby="hw-final-title">
        <div><h2 id="hw-final-title">Get your crew on the grass.</h2><p>A Halloween tournament now. Snowbird Showdown next.</p></div>
        <a className="hw-button" href={registrationUrl}>Register your team <FiArrowRight aria-hidden="true" /></a>
      </section>
    </main>
    <footer className="hw-footer hw-wrap"><a href="/">Explore Snowbird Showdown <FiArrowRight aria-hidden="true" /></a><p>Questions? <a href="mailto:director@sidewinderva.com">director@sidewinderva.com</a></p></footer>
  </div>;
}
